<template>
  <div>
    <div class="period-btn-wrapper">
      <button
        :class="{ 'cursor-default': !hasOtherPeriods }"
        :id="`${perfix}-periods-btn`"
        class="flex gap-2 items-baseline"
        @click="onBtnClick"
      >
        <displayed-time-format
          :period="firstPeriod"
          show-weekday
          text-size-class="sm:text-lg text-xl"
          text-weight-class="font-medium"
        />
        <i v-if="hasOtherPeriods" class="icon-chevron-down text-gray-500 text-xl" />
      </button>
      <div
        v-if="showPopover"
        :id="`${perfix}-other-periods-popover`"
        class="absolute bg-white min-w-max p-4 top-6 right-0 rounded shadow-md z-20"
      >
        <ul>
          <li v-for="(period, index) in otherPeriods" :key="`period-${index}`">
            <displayed-time-format
              :period="period"
              text-size-class="text-base"
              text-weight-class="font-normal"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import PeriodsDisplay from './PeriodsDisplay';

export default PeriodsDisplay;
</script>

<style lang="scss" scoped>
@import 'PeriodsDisplay';
</style>
